import { render, staticRenderFns } from "./CreditsSummaryCard.vue?vue&type=template&id=1b83f21b&scoped=true"
import script from "./CreditsSummaryCard.vue?vue&type=script&lang=js"
export * from "./CreditsSummaryCard.vue?vue&type=script&lang=js"
import style0 from "./CreditsSummaryCard.vue?vue&type=style&index=0&id=1b83f21b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b83f21b",
  null
  
)

export default component.exports